module.exports = __webpack_public_path__ + "static/media/fold-folding.29dc4486.png";